const PERFORNAMCE = {
  TRADES_LIMIT: 80,
  // The minimum interval to update the list of trades.
  TRADES_UPDATE_MINIMUM_INTERVAL: 190,
  // asks bids
  DEPTH_LIMIT: 500,
  // The socket server pushes 2 messages of this type per second,
  // so it is unnecessary to limit the rate for now.
  // However, we limit the frequency
  DEPTH_UPDATE_MINIMAL_INTERVAL: 600,

  // The miniseconds which is allowed
  //   since the dispatch method has been scheduled as `setTimeout(callback, 0)`
  //   before it is invoked.
  // If a setTimeout(callback, 0) timer takes too long to callback,
  //   which indicates the I/O event loop of v8 or CPU is too busy,
  //   we will dispose the invocation of callback.
  EVENT_LOOP_TOLERANCE: 20,
  MAX_WAIT: 1000, // ensure execution after MAX_WAIT
};

export default PERFORNAMCE;
